<template>
  <div>
    <div class="vx-row mb-5">
      <div class="vx-col lg:w-1/4 md:w-1/2 sm:w-1/2 w-1/2 mt-5">
        <vx-card>
          <h1>{{ decimalPercentFormat(anualInterest) }}</h1>
          <p class="mt-1 text-lg">Tasa de interés</p>
        </vx-card>
      </div>
      <div class="vx-col lg:w-1/4 md:w-1/2 sm:w-1/2 w-1/2 mt-5">
        <vx-card>
          <h1>{{ yearsTerm }} años</h1>
          <p class="mt-1 text-lg">Plazo</p>
        </vx-card>
      </div>
      <div class="vx-col lg:w-1/4 md:w-1/2 sm:w-1/2 w-1/2 mt-5">
        <vx-card card-background="primary">
          <h1 class="text-white">{{ decimalPercentFormat(projectMarketShare, 6) }}</h1>
          <p class="text-white mt-1 text-lg">Participación en el mercado</p>
        </vx-card>
      </div>
    </div>
    <vx-card>
      <div class="vx-row">
        <div class="vx-col w-full">
          <p class="card-sub-title mb-3">{{ currentStatus }}.</p>
          <p v-if="currentEvent">{{ humanDateFormat(currentEvent.created_at) }}: {{ currentEvent.event }} </p>
          <p v-else>Consulta más detalles sobre los eventos de cobranza que han ocurrido en tu proyecto a lo largo del
            plazo del crédito al dar clic en el botón "Eventos de la cobranza".</p>
        </div>
      </div>
      <div class="vx-row mt-6">
        <div class="vx-col w-full">
          <div class="flex flex-wrap items-center">
            <vs-button type="border" class="sm:px-base px-4 mr-2 mb-3" @click="showCashingLogEvents">Eventos de la
              cobranza</vs-button>
          </div>
        </div>
      </div>
    </vx-card>
    <!-- Popup para tablas -->
    <vs-popup :active.sync="isPopupActive" :title="alias" class="max-width-popup">
      <investor-cashing-event-logs :project-id="projectId" v-if="currentView === 3" />
    </vs-popup>
  </div>
</template>

<script>
import creditStatusesHelper from "@mixins/creditStatusesHelper";
import formatHelper from "@mixins/formatHelper";
import PaymentsPlan from "@components/investor/invested/PaymentsPlan";
import InvestorProjectEvents from "@components/investor/invested/InvestorProjectEvents";
import InvestorCashingEventLogs from "@components/investor/invested/InvestorCashingEventLogs";
import ProjectEvidences from "@components/investor/invested/ProjectEvidences";
import ProjectContracts from "@components/investor/invested/ProjectContracts";
import dateHelper from "@mixins/dateHelper";
export default {
  name: "InvestmentSecondaryMarket",
  props: {
    projectData: { type: Object, required: true },
    projectId: { type: [String, Number], required: true },
    alias: { type: [String], required: true },
  },
  data() {
    return {
      currentView: 0,
      cashingEvents: [],
    }
  },
  components: {
    PaymentsPlan,
    InvestorProjectEvents,
    InvestorCashingEventLogs,
    ProjectEvidences,
    ProjectContracts
  },
  mixins: [creditStatusesHelper, formatHelper, dateHelper],
  async mounted() {
    this.showLoading(true)
    await this.getEventsInfo();
    this.showLoading(false)
  },
  computed: {
    currentStatus() {
      return this.creditStatusName(this.projectData.finance.asset_status, this.projectData.finance.credit_status);
    },
    currentEvent() {
      if (this.cashingEvents.length && this.cashingEvents.length > 0) {
        return this.cashingEvents[0];
      }
      else {
        return null;
      }
    },
    currentDescription() {
      if (this.cashingEvents.length && this.cashingEvents.length > 0) {
        return this.cashingEvents[0].event;
      }
      else {
        return null;
      }
    },
    isPopupActive: {
      get() {
        return this.$store.state.isProjectDetailPopupActive;
      },
      set(val) {
        this.$store.commit("TOGGLE_IS_PROJECT_DETAIL_POPUP_ACTIVE", val);
      }
    },
    paidCount() {
      return this.projectData.finance.paid_count;
    },
    totalTerms() {
      return this.projectData.finance.term;
    },
    anualInterest() {
      return this.projectData.finance.anual_interest;
    },
    projectMarketShare() {
      return this.projectData.project.project_market_share;
    },
    yearsTerm() {
      return this.projectData.finance.term / 12;
    }
  },
  methods: {
    async getEventsInfo() {
      try {
        const response = await axios.get(`api/inversionista/inversiones/resumen/${this.projectId}/cashingEventLogs`);
        this.cashingEvents = response.data;
      }
      catch (e) {
      }
    },
    showCashingLogEvents() {
      // se genera log de accion
      let extraParams = {
        project_id: this.projectId,
        alias: this.alias
      };
      this.saveInvestorLogAction("LC10-20", extraParams);
      this.currentView = 3;
      this.$store.commit('TOGGLE_IS_PROJECT_DETAIL_POPUP_ACTIVE', true)
    },
    backToDetail() {
      this.currentView = 0;
    }
  }
}
</script>

<style scoped></style>